module.exports = __webpack_public_path__ + "static/media/bateria_uszkodzona.3651e9f5.svg";